<div class="public-terms">
  <hip-modal>
    <lib-privacy-policy></lib-privacy-policy>
  </hip-modal>
</div>
